import { ThemeProps } from "@rjsf/core";
import BaseInputTemplate from "./Templates/BaseInputTemplate";
import FieldTemplate from "./Templates/FieldTemplate";
import ObjectFieldTemplate from "./Templates/ObjectFieldTemplate";
import TextareaWidget from "./Widgets/TextareaWidget";
import ArrayFieldTemplate from "./Templates/ArrayFieldTemplate";
import ErrorListTemplate from "./Templates/ErrorListTemplate";
import CheckboxWidget from "./Widgets/CheckboxWidget";
import CheckboxesWidget from "./Widgets/CheckboxesWidget";
import RadioWidget from "./Widgets/RadioWidget";
import SelectWidget from "./Widgets/SelectWidget";

export const Theme: ThemeProps = {
  templates: {
    BaseInputTemplate,
    FieldTemplate,
    ObjectFieldTemplate,
    ArrayFieldTemplate,
    ErrorListTemplate
  },
  widgets: {
    CheckboxWidget,
    CheckboxesWidget,
    RadioWidget,
    SelectWidget,
    TextareaWidget
  }
};
